<template>
  <div class="wecoupon-mall-info">
    <div class="top">
      <div class="name">{{ mallInfo.name }}</div>
      <FitButton type="default" class="btn" @click="handleClick">{{ i18n('查看') }}</FitButton>
    </div>
    <div class="desc text">{{ mallInfo.desc }}</div>
    <div class="addr text" :class="{ 'addr-vsible': !!mallInfo.addr }">{{ i18n('地址：') }}{{ mallInfo.addr }}</div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue-demi';
import { FitButton } from '@tencent/wphk-ui';
import { MallInfo } from '../type';
import { i18n } from '../../../i18n';
import { windowHelper } from '@tencent/ppd-base-libs';

export default defineComponent({
  name: 'MallContentInfo',
  components: {
    FitButton,
  },
  props: {
    data: {
      type: Object as PropType<MallInfo>,
      required: true,
    },
  },
  setup(props, context) {
    const mallInfo = computed(() => {
      const { id, name, desc, addr } = props.data;
      return { id, name, desc, addr };
    });

    function handleClick() {
      const url = `//prom.wechatpay.com.hk/merchant-channel/index.shtml?ADTAG=mall&spId=${encodeURIComponent(mallInfo.value.id)}`;
      windowHelper.redirect(url);
    }

    return {
      i18n,
      mallInfo,
      handleClick,
    };
  },
});
</script>

<style lang="less" scoped>
@import (reference) '../../../less/main.less';

.wecoupon-mall-info {
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .name {
      flex: 1;
      font-family: PingFang HK;
      font-size: 32 / @rem;
      font-weight: 500;
      line-height: 48 / @rem;
      text-align: left;
      color: #ffffff;
      text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.45);
    }

    .btn {
      min-width: 88 / @rem;
      font-size: 28 / @rem;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 40 / @rem;
      padding: 8 / @rem 16 / @rem;
      height: auto;
    }
  }

  .text {
    text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.45);
    font-family: PingFang HK;
    font-size: 24 / @rem;
    line-height: 32 / @rem;
    font-weight: 500;
    color: #ffffff;
  }

  .desc {
    margin-top: 8 / @rem;
    height: 60 / @rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .addr {
    margin-top: 12 / @rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    visibility: hidden;

    &-vsible {
      visibility: visible;
    }
  }
}
</style>
